var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.6667 21.3333C18.6667 23.6933 17.64 25.8266 16 27.2799C14.5867 28.5599 12.72 29.3333 10.6667 29.3333C6.25335 29.3333 2.66669 25.7466 2.66669 21.3333C2.66669 17.6533 5.17335 14.5333 8.56002 13.6133C9.48002 15.9333 11.4534 17.7199 13.8934 18.3866C14.56 18.5733 15.2667 18.6666 16 18.6666C16.7334 18.6666 17.44 18.5733 18.1067 18.3866C18.4667 19.2933 18.6667 20.2933 18.6667 21.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.667C24 11.707 23.8 12.707 23.44 13.6137C22.52 15.9337 20.5467 17.7203 18.1067 18.387C17.44 18.5737 16.7333 18.667 16 18.667C15.2667 18.667 14.56 18.5737 13.8933 18.387C11.4533 17.7203 9.48 15.9337 8.56 13.6137C8.2 12.707 8 11.707 8 10.667C8 6.25366 11.5867 2.66699 16 2.66699C20.4133 2.66699 24 6.25366 24 10.667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.3333 21.3333C29.3333 25.7466 25.7467 29.3333 21.3333 29.3333C19.28 29.3333 17.4133 28.5599 16 27.2799C17.64 25.8266 18.6667 23.6933 18.6667 21.3333C18.6667 20.2933 18.4667 19.2933 18.1067 18.3866C20.5467 17.7199 22.52 15.9333 23.44 13.6133C26.8267 14.5333 29.3333 17.6533 29.3333 21.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponents);
export default __webpack_public_path__ + "static/media/components.49fe110a60854ecd5755000725372b23.svg";
export { ForwardRef as ReactComponent };